<template>
    <div class="page marginCenter">
        <el-form
            ref="submitForm"
            :inline="true"
            :rules="rules"
            :model="form.applyBasic"
            label-position="right"
            label-width="130px"
        >
            <div class="marginBom30 marginTop30 categoryTitle2 flex-yCenter flex-sb">
                <div class="left flex-center">
                    <div class="line"></div>
                    <span>新增进修考核</span>
                </div>
            </div>
            <div class="section1">
                <div class="sectionTitle fsize20">个人基本信息</div>
                <div class="content padding">
                    <div class="flex-sb">
                        <el-form-item class="fsize22" label="姓名：">
                            <el-input
                                class="marginRt18"
                                disabled
                                placeholder="请输入"
                                v-model="form.applyBasic.userName"
                                clearable
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="userSex" label="性别：">
                            <el-radio-group disabled v-model="form.applyBasic.userSex">
                                <el-radio
                                    v-for="item in dict.type.sys_user_sex"
                                    :key="item.value"
                                    :label="item.value"
                                    >{{ item.raw.dictLabel }}</el-radio
                                >
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="出生年月：">
                            <el-input
                                placeholder="请输入"
                                disabled
                                :value="
                                    form.applyBasic.idCard.slice(6, 10) + '.' + form.applyBasic.idCard.slice(10, 12)
                                "
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="fsize22" label="工号：">
                            <el-input
                                class="marginRt18"
                                placeholder="请输入"
                                disabled
                                v-model="form.applyBasic.workerNo"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="身份证号码：">
                            <el-input
                                placeholder="请输入"
                                disabled
                                :value="form.applyBasic.idCard"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="fsize22" label="执业资格证号：">
                            <el-input
                                class="marginRt18"
                                placeholder="请输入"
                                disabled
                                v-model="form.applyBasic.credentialsNo"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item class="fsize22" label="执业注册证号：">
                            <el-input
                                class="marginRt18"
                                placeholder="请输入"
                                disabled
                                v-model="form.applyBasic.practitionerNo"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="选送工作单位：" label-width="130px">
                            <el-input
                                disabled
                                class="marginRt18"
                                placeholder="请输入"
                                v-model="form.applyBasic.selectionUnit"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item class="fsize22" label="进修起止时间：">
                            <div class="flex-sb">
                                <el-input
                                    placeholder="请输入"
                                    disabled
                                    v-model="form.applyBasic.trainBeginDate"
                                    style="width: 45%"
                                ></el-input>
                                <span>-</span>
                                <el-input
                                    placeholder="请输入"
                                    disabled
                                    v-model="form.applyBasic.trainEndDate"
                                    style="width: 45%"
                                ></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="fsize22" label="进修总时长：">
                            <el-input
                                class="marginRt18"
                                disabled
                                placeholder="请输入"
                                style="width: 100%"
                                :value="
                                    form.trainList.reduceRight((a, b) => Number(a) + Number(b.trainDuration), 0) +
                                    '个月'
                                "
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item class="fsize22" label="开户银行：" >
                            <el-select
                                v-model="form.applyBasic.depositBank"
                                placeholder="请选择"
                                style="width: 100%"
                                clear="marginRt18"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict.type.deposit_bank"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="银行卡号：" >
                            <el-input
                                class="marginRt18"
                                placeholder="请输入"
                                v-model="form.applyBasic.bankNo"
                                clearable
                                style="width: 100%"
                                maxlength="19"
                            ></el-input>
                            <div class="fcolor_gray">（必须是本人银行卡号）</div>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="结业证书号：" prop="certNo">
                            <el-input
                                class="marginRt18"
                                placeholder="请输入"
                                v-model="form.applyBasic.certNo"
                                disabled
                                clearable
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="section1">
                <div class="sectionTitle fsize20">进修信息</div>
                <div class="content padding" v-for="(item, index) in form.trainList" :key="index">
                    <div class="flex-sb">
                        <el-form-item class="fsize22" label="进修科室：">
                            <el-input
                                class="marginRt18"
                                disabled
                                placeholder="请输入"
                                v-model="item.deptName"
                                clearable
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="userSex" label="带教老师：">
                            <el-input placeholder="请输入" v-model="item.teacherName" style="width: 100%"></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="进修方向：">
                            <el-input disabled placeholder="请输入" v-model="item.trainDirectionName" style="width: 100%"></el-input>
                        </el-form-item>
                    </div>
                    <div class="sectionTitle fsize20">进修期间工作情况（{{ item.deptName }}）</div>
                    <div class="flex-sb">
                        <el-form-item label="到岗（天）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.attendAttendance"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="迟到（天）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.attendLate"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="早退（天）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.attendLeaveEarly"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="请假（天）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.leaveRequestsNumber"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="医疗纠纷（起）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.medicalDispute"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="医疗差错（起）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.medicalError"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-sb">
                        <el-form-item label="医疗事故（起）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.medicalMalpractice"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="教学查房（次）：">
                            <el-input
                                placeholder="请输入"
                                v-model="item.trainProcess.teachRounds"
                                type="number"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <!-- <el-form-item label="">
            <el-input placeholder="请输入" v-model="item.trainProcess.teachRounds" style="width: 100%">
            </el-input>
          </el-form-item>-->
                    <!-- <div class="fsize22 flex-yCenter marginBom24">
                        <div class="fsize22 flex-yCenter" style="flex-grow: 1">
                            <span class="marginRt18">参与诊断治疗技术操作</span>
                            <div class="flex-sb flex-yCenter" style="flex-grow: 1">
                                <el-button type="primary" class="whiteBtn2" @click="add(index, 1)" style="width: 100px"
                                    >新增</el-button
                                >
                                <i class="el-icon-delete pointer" @click="remove(index, 1)"></i>
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="item.trainProcessDiagnosisList"
                        border
                        style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
                        @selection-change="handleSelectionChange1"
                    >
                        <el-table-column type="selection" align="center" width="100"></el-table-column>
                        <el-table-column type="index" label="序号" align="center" width="150"></el-table-column>
                        <el-table-column prop="name" label="操作名称" align="center"></el-table-column>
                        <el-table-column prop="num" label="次数" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="登记时间" align="center"></el-table-column>
                    </el-table> -->
                    <div class="fsize22 flex-yCenter marginBom24">
                        <div class="marginTop24 fsize22 flex-yCenter" style="flex-grow: 1">
                            <span class="marginRt18">参加业务学习内容</span>
                            <div class="flex-sb flex-yCenter" style="flex-grow: 1">
                                <el-button type="primary" class="whiteBtn2" @click="add(index, 2)" style="width: 100px"
                                    >新增</el-button
                                >
                                <i class="el-icon-delete pointer" @click="remove(index, 2)"></i>
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="item.trainProcessStudyList"
                        border
                        style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
                        @selection-change="handleSelectionChange2"
                    >
                        <el-table-column type="selection" align="center" width="100"></el-table-column>
                        <el-table-column type="index" label="序号" align="center" width="150"></el-table-column>
                        <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
                        <el-table-column prop="courseHour" label="学时（每期）" align="center"></el-table-column>
                        <el-table-column prop="teacherName" label="授课老师" align="center"></el-table-column>
                        <el-table-column label="完成情况" align="center">
                            <span slot-scope="scope">{{ scope.row.finishStatus == 0 ? '未完成' : '已完成' }}</span>
                        </el-table-column>
                        <el-table-column prop="createTime" label="登记时间" align="center"></el-table-column>
                        <el-table-column prop="notes" label="备注" align="center"></el-table-column>
                    </el-table>
                    <!-- <div class="fsize22 flex-yCenter marginBom24">
                        <div class="marginTop24 fsize22 flex-yCenter" style="flex-grow: 1">
                            <span class="marginRt18">参加手术操作情况</span>
                            <div class="flex-sb flex-yCenter" style="flex-grow: 1">
                                <el-button type="primary" class="whiteBtn2" @click="add(index, 3)" style="width: 100px"
                                    >新增</el-button
                                >
                                <i class="el-icon-delete pointer" @click="remove(index, 3)"></i>
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="item.trainProcessSurgeryList"
                        border
                        style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
                        @selection-change="handleSelectionChange3"
                    >
                        <el-table-column type="selection" align="center" width="100"></el-table-column>
                        <el-table-column type="index" label="序号" align="center" width="150"></el-table-column>
                        <el-table-column prop="name" label="手术/操作名称" align="center"></el-table-column>
                        <el-table-column prop="caseNo" label="病历号" align="center"></el-table-column>
                        <el-table-column prop="operationTime" label="操作时间" align="center"></el-table-column>
                        <el-table-column prop="name" label="完成情况" align="center">
                            <span slot-scope="scope">{{ scope.row.finishStatus == 0 ? '未完成' : '已完成' }}</span>
                        </el-table-column>
                        <el-table-column prop="surgeryNotes" label="备注" align="center"></el-table-column>
                    </el-table> 
                   <div class="fsize22 flex-yCenter marginBom24">
                        <div class="marginTop24 fsize22 flex-yCenter" style="flex-grow: 1">
                            <span class="marginRt18">参加实验（动物）培训情况</span>
                            <div class="flex-sb flex-yCenter" style="flex-grow: 1">
                                <el-button type="primary" class="whiteBtn2" @click="add(index, 4)" style="width: 100px"
                                    >新增</el-button
                                >
                                <i class="el-icon-delete pointer" @click="remove(index, 4)"></i>
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="item.trainProcessExperimentList"
                        border
                        style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
                        @selection-change="handleSelectionChange4"
                    >
                        <el-table-column type="selection" align="center" width="100"></el-table-column>
                        <el-table-column type="index" label="序号" align="center" width="150"></el-table-column>
                        <el-table-column
                            prop="experimentalModule"
                            label="实验模块（项目）"
                            align="center"
                        ></el-table-column>
                        <el-table-column prop="completion" label="完成情况或例数" align="center"></el-table-column>
                        <el-table-column prop="instructor" label="指导老师" align="center"></el-table-column>
                        <el-table-column prop="location" label="地点" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="登记时间" align="center"></el-table-column>
                    </el-table> -->
                    <div class="title marginTop24">
                        <el-form-item
                            :inline="false"
                            prop="politicalPerformance"
                            label="其他补充"
                            label-width="100%"
                            style="text-align: left"
                        >
                            <el-input
                                class="marginTop24"
                                type="textarea"
                                :rows="3"
                                placeholder="请输入内容"
                                v-model="item.otherSupplements"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="padding">
                    <div class="marginBom24 title">
                        <el-form-item
                            :inline="false"
                            prop="appraisalPerson"
                            label="个人总结与自评"
                            label-width="100%"
                            style="text-align: left"
                        >
                            <el-input
                                class="marginTop24"
                                type="textarea"
                                :rows="3"
                                :maxlength="300"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="form.applyBasic.appraisalPerson"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="overflow marginBom30">
                        <el-button class="fr submit btn300 blueBtn1" @click="submit" type="primary"
                            >确认并提交</el-button
                        >
                        <el-button class="fr btn300 blueBtn2 marginRt18" type="primary" @click="staging">暂存</el-button>
                    </div>
                </div>
            </div>
        </el-form>
        <Model :showState="addObj.showState" @confirm="addConfirm" @cancel="addCancel" :title="addObj.title">
            <template #content>
                <el-form ref="addForm" :model="addObj.form" :rules="addObj.rules" label-width="auto">
                    <template v-if="addObj.type == 1">
                        <el-form-item label="操作名称：" prop="name">
                            <el-input v-model="addObj.form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="次数：" prop="num">
                            <el-input v-model.number="addObj.form.num" type="number"></el-input>
                        </el-form-item>
                    </template>
                    <template v-else-if="addObj.type == 2">
                        <el-form-item label="课程名称：" prop="courseName">
                            <el-input v-model="addObj.form.courseName"></el-input>
                        </el-form-item>
                        <el-form-item label="学时（每期）：" prop="courseHour">
                            <el-input v-model="addObj.form.courseHour"></el-input>
                        </el-form-item>
                        <el-form-item label="授课老师：" prop="teacherName">
                            <el-input v-model="addObj.form.teacherName"></el-input>
                        </el-form-item>
                        <el-form-item label="完成情况：" prop="finishStatus">
                            <el-select v-model="addObj.form.finishStatus" placeholder="请选择" style="width: 100%">
                                <el-option
                                    v-for="item in stateList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                v-model="addObj.form.notes"
                                maxlength="30"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </template>
                    <template v-else-if="addObj.type == 3">
                        <el-form-item label="手术/操作名称：" prop="name">
                            <el-input v-model="addObj.form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="病例号：" prop="caseNo">
                            <el-input v-model="addObj.form.caseNo"></el-input>
                        </el-form-item>
                        <el-form-item label="操作时间：" prop="operationTime">
                            <el-date-picker
                                v-model="addObj.form.operationTime"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>

                        <el-form-item label="完成情况：" prop="finishStatus">
                            <el-select v-model="addObj.form.finishStatus" placeholder="请选择">
                                <el-option
                                    v-for="item in stateList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                v-model="addObj.form.surgeryNotes"
                                maxlength="30"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </template>
                    <template v-else-if="addObj.type == 4">
                        <el-form-item label="实验模块（项目）：" prop="experimentalModule">
                            <el-input v-model="addObj.form.experimentalModule"></el-input>
                        </el-form-item>
                        <el-form-item label="完成情况或例数：" prop="completion">
                            <el-input v-model="addObj.form.completion"></el-input>
                        </el-form-item>
                        <el-form-item label="指导老师：" prop="instructor">
                            <el-input v-model="addObj.form.instructor"></el-input>
                        </el-form-item>
                        <el-form-item label="地点：" prop="location">
                            <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                v-model="addObj.form.location"
                                maxlength="30"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </template>
                </el-form>
            </template>
        </Model>
    </div>
</template>
<script>
//operationType 0无需上传 1上传凭证 2未确认 3已上传 4已确认
import { trainApplyGetAssessment, trainApplyUpdateAssessment, trainApplyStorageAssessment, systemDirectionList ,trainApplyStorageAssessmentPost} from '@/utils/api';
import { parseTime } from '@/utils/ruoyi';
import { v4 as uuidv4 } from 'uuid';
// import { format } from "echarts";
export default {
    dicts: ['sys_user_sex', 'deposit_bank'],
    components: {},
    data() {
        return {
            form: {
                applyBasic: {
                    idCard: ''
                },
                trainList: [],
                user: {}
            },
            rules: {
                // depositBank: {
                //     required: true,
                //     trigger: 'change',
                //     message: '开户银行不能为空'
                // },
                // bankNo: [
                //     { required: true, trigger: 'blur', message: '银行卡号不能为空' },
                //     { max: 19, min: 16, trigger: 'blur', message: '银行卡号格式不正确' }
                // ],
                appraisalPerson: {
                    required: true,
                    trigger: 'blur',
                    message: '个人总结与自评不能为空'
                }
            },
            trainDirectionList: [],
            addObj: {
                title: '',
                form: {},
                rules: {},
                showState: false
            },
            selectList1: [],
            selectList2: [],
            selectList3: [],
            selectList4: [],
            stateList: [
                { label: '未完成', value: 0 },
                { label: '已完成', value: 1 }
            ]
        };
    },
    created() {
        this.getData();
    },
    methods: {
            // 获取进修方向
        async getDirectionList(jobTitle) {
          const res = await systemDirectionList({
            jobTitle,
            pageSize: 9999
          })
          this.trainDirectionList = res.rows
        },
        handleSelectionChange1(list) {
            this.selectList1 = list;
        },
        handleSelectionChange2(list) {
            this.selectList2 = list;
        },
        handleSelectionChange3(list) {
            this.selectList3 = list;
        },
        handleSelectionChange4(list) {
            this.selectList4 = list;
        },
        getData() {
            const trainAssessmentFlag = this.$route.query.trainAssessmentFlag;
            const applyId = this.$route.query.applyId;
            
            trainApplyGetAssessment(applyId).then((res) => {
                if (res.code == 200) {
                    this.form = res.data;
                    this.initUuid();
                    this.getDirectionList(this.form.applyBasic.post);
                    
                    // trainAssessmentFlag == 0 时从暂存获取数据覆盖
                    if (trainAssessmentFlag == 0) {
                        trainApplyStorageAssessment(applyId).then((storageRes) => {
                            if (storageRes.code == 200 && storageRes.data) {
                                this.form = storageRes.data;
                                this.initUuid();
                                this.getDirectionList(this.form.applyBasic.post);
                            }
                        });
                    }
                }
            });
        },
        // 初始化UUID
        initUuid() {
            this.form.trainList.forEach((item) => {
                ['trainProcessDiagnosisList', 'trainProcessStudyList', 'trainProcessSurgeryList', 'trainProcessExperimentList'].forEach(listKey => {
                    item[listKey].forEach((son) => {
                        son.uuid = uuidv4();
                    });
                });
            });
        },
        // 打开新增
        add(index, type) {
            let title = '新增';
            let rules = {};
            if (type == 1) {
                rules = {
                    name: [{ required: true, message: '操作名称不能为空', trigger: 'blur' }],
                    num: [{ required: true, message: '次数不能为空', trigger: 'blur' }]
                };
            } else if (type == 2) {
                rules = {
                    courseName: { required: true, message: '课程名称不能为空', trigger: 'blur' },
                    courseHour: { required: true, message: '学时不能为空', trigger: 'blur' },
                    teacherName: { required: true, message: '授课老师不能为空', trigger: 'blur' },
                    finishStatus: { required: true, message: '完成情况是必选的', trigger: 'change' }
                };
            } else if (type == 3) {
                rules = {
                    name: [{ required: true, message: '手术/操作名称', trigger: 'blur' }],
                    caseNo: [{ required: true, message: '病历号', trigger: 'blur' }],
                    operationTime: [{ required: true, message: '操作时间', trigger: 'change' }],
                    finishStatus: [{ required: true, message: '完成情况', trigger: 'change' }]
                };
            } else if (type == 4) {
                rules = {
                    experimentalModule: { required: true, message: '实验模块不能为空', trigger: 'blur' },
                    completion: { required: true, message: '完成情况或例数不能为空', trigger: 'blur' },
                    instructor: { required: true, message: '指导老师不能为空', trigger: 'blur' },
                    location: { required: true, message: '地点不能为空', trigger: 'blur' }
                };
            }
            this.addObj.trainObj = this.form.trainList[index];
            this.addObj.title = title;
            this.addObj.type = type;
            this.addObj.index = index;
            this.addObj.rules = rules;
            this.addObj.showState = true;
        },
        // 取消新增
        addCancel() {
            this.addObj.form = {};
            this.$refs.addForm.resetFields();
            this.addObj.showState = false;
        },
        // 新增确认
        addConfirm() {
            this.$refs.addForm.validate((vaild) => {
                if (vaild) {
                    switch (this.addObj.type) {
                        case 1:
                            this.form.trainList[this.addObj.index].trainProcessDiagnosisList.push({
                                ...this.addObj.form,
                                uuid: uuidv4(),
                                trainId: this.addObj.trainObj.trainId,
                                createTime: parseTime(new Date()),
                                createBy: this.form.applyBasic.userName
                            });
                            break;
                        case 2:
                            this.form.trainList[this.addObj.index].trainProcessStudyList.push({
                                ...this.addObj.form,
                                uuid: uuidv4(),
                                trainId: this.addObj.trainObj.trainId,
                                createTime: parseTime(new Date()),
                                createBy: this.form.applyBasic.userName
                            });
                            break;
                        case 3:
                            this.form.trainList[this.addObj.index].trainProcessSurgeryList.push({
                                ...this.addObj.form,
                                uuid: uuidv4(),
                                trainId: this.addObj.trainObj.trainId,
                                createTime: parseTime(new Date()),
                                createBy: this.form.applyBasic.userName
                            });
                            break;
                        case 4:
                            this.form.trainList[this.addObj.index].trainProcessExperimentList.push({
                                ...this.addObj.form,
                                uuid: uuidv4(),
                                trainId: this.addObj.trainObj.trainId,
                                createTime: parseTime(new Date()),
                                createBy: this.form.applyBasic.userName
                            });
                            break;
                        default:
                            break;
                    }
                    this.addCancel();
                }
            });
        },
        // 删除
        remove(index, type) {
            console.log(type);
            if (
                this[type == 1 ? 'selectList1' : type == 2 ? 'selectList2' : type == 3 ? 'selectList3' : 'selectList4']
                    .length > 0
            ) {
                this.$confirm('确认删除', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let list =
                        this.form.trainList[index][
                            type == 1
                                ? 'trainProcessDiagnosisList'
                                : type == 2
                                ? 'trainProcessStudyList'
                                : type == 3
                                ? 'trainProcessSurgeryList'
                                : 'trainProcessExperimentList'
                        ];
                    for (let index = 0; index < list.length; index++) {
                        const item = list[index];
                        this[
                            type == 1
                                ? 'selectList1'
                                : type == 2
                                ? 'selectList2'
                                : type == 3
                                ? 'selectList3'
                                : 'selectList4'
                        ].forEach((son) => {
                            if (item.uuid == son.uuid) {
                                list.splice(index, 1);
                                index--;
                            }
                        });
                    }
                });
            } else {
                this.$message.warning('请先选中数据在删除');
            }
        },
        // 暂存
        staging() {
            trainApplyStorageAssessmentPost(this.form).then((res) => {
                if (res.code == 200) {
                    this.$message.success('暂存成功');
                }
            });
        },
        // 提交
        submit() {
            this.$refs.submitForm.validate((vaild) => {
                if (vaild) {
                    // trainProcessSurgeryList
                    let flag = this.form.trainList.every((item) => {
                        return item.trainProcessSurgeryList.every((son) => {
                            if (son.operationTime) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                    });
                    console.log(flag);
                    if (flag) {
                        const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        console.log(this.form);
                        trainApplyUpdateAssessment(this.form)
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$router.go(-1);
                                    this.$message.success('考核成功');
                                }
                            })
                            .finally(() => {
                                loading.close();
                            });
                    } else {
                        this.$message.error('请先填写所有手术操作时间!!!');
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .title {
    .el-form-item {
        width: 100%;
    }

    .el-form-item__label {
        display: block;
        width: 100%;
        text-align: left;
        font-size: 22px;
        color: #333;
        padding: 0;
    }

    .el-form-item__content {
        display: block;
        width: 100%;
    }
}

.sectionTitle {
    margin: 24px 0 12px 0;
    font-weight: 600;
}

.padding {
    padding: 24px 24px 30px 24px;
}

::v-deep .section1 {
    .content {
        .flex-sb {
            .el-form-item {
                width: 50%;
                margin-right: 0;
                display: flex;

                .el-form-item__content {
                    flex-grow: 1;
                }

                .el-form-item__label {
                    padding: 0;
                }
            }
        }
    }
}
</style>
